<template>
  <div class="protocol-edit-container">
    <el-form :model="postForm" class="modal" label-width="100px">
      <el-form-item label="协议名称" prop="name">
        <el-input v-model="postForm.name" />
      </el-form-item>
      <el-form-item label="协议内容" prop="content">
        <div>
          <tinymce :height="300" v-model="postForm.content"/>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import { getAgreementById, updateAgreement } from '@/api/site'

export default {
  name: 'ProtocolEdit',
  components: { Tinymce },
  data() {
    return {
      postForm: {},
      params: this.$route.params
    }
  },
  created() {
    this.getAgreementById()
  },
  methods: {
    handleEdit(index, row) {
      console.log(index, row);
    },
    onSubmit() {
      this.updateAgreement()
    },
    getAgreementById() {
      const params = this.$route.params
      getAgreementById(params.id).then(response => {
        this.postForm= response.data
      })
    },
    updateAgreement() {
      const params = this.$route.params
      const data = {
        id: params.id,
        name: this.postForm.name,
        content: this.postForm.content
      }
      updateAgreement(data).then(response => {
        const data = response.data
        if(data) {
          this.$message({
            message: '更新成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .protocol-edit-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }

    /* dialog modal start */
    .el-dialog {
      width: 540px;
      .el-form-item {
        .el-input {
          width: 300px;
        }
      }
    }
    /* dialog modal end*/
  }
</style>
